export default __webpack_public_path__ + "delivery-checke0d165.png";